export default __webpack_public_path__ + "static/media/header-back.34608207.jpg";